export const TABLE_MEDIA_QUERY = "(max-width: 768px)";
export const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";
